<template>
  <div>
    <!-- 溯源主体统计 -->
    <div class="echart_zonglan" style="height: 30rem">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">溯源主体统计</span>
      </div>
      <div class="suyuanBpx">
        <div id="echart_quality_one"></div>
        <div class="suyuandetail">
          <div class="div">
            <div class="table_border">
              <div v-show="DataMonth" class="monthBox">
                <p>数据未更新</p>
              </div>
              <table
                class="table_cont"
                border="1"
                cellpadding="0"
                v-show="!DataMonth"
              >
              <thead>
                <tr
                  style="
                    color: #1eeabe;
                    opacity: 0.69;
                    background: #39819a;
                    border: 1px solid #3a6c83;
                  "
                >
                  <td style="width: 26%">名称</td>
                  <td style="width: 13%">类型</td>
                  <td style="width: 13%">法人代表</td>
                  <td style="width: 26%">联系电话</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in tableList" :key="index">
                  <td style="width: 26%">{{ item.companyName }}</td>
                  <td style="width: 13%">{{ item.type }}</td>
                  <td style="width: 13%">{{ item.legalPerson }}</td>
                  <td style="width: 26%">{{ item.phone }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品统计-育苗产品 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">产品统计-育苗类</span>
      </div>
      <div id="echart_quality_two"></div>
    </div>
    <!-- 产品统计-屠宰产品 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font" class="icon_img" alt="" />
        <span class="people_font">产品统计-屠宰类</span>
      </div>
      <div id="echart_quality_three"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      //溯源主体统计
      sourceList: [],
      oneType: [],
      oneNumber: [],
      DataMonth: false,
      tableList: [],
      // 产品统计-育苗产品
  

      // 产品统计-屠宰产品
      twoYear: ["2016", "2017", "2018", "2019", "2020", "2021"],
      cowList: [12, 13, 14, 15, 49, 56],
      sheepList: [24, 36, 9, 11, 19, 37],

      // 数据来源
      Data_txt: "",
    };
  },
  mounted() {
    this.init_one();
    this.init_two();
    this.init_three();
  },
  methods: {
    // 溯源主体统计
    init_one() {
      // 调取接口
      var data_beian = plOtherDataInterface.getZlsyCompanyStaticByTypeList();
      var list = [];
      data_beian.forEach((element) => {
        list.push(element.theType);
      });
      this.oneType = list;
      this.getList(this.oneType[0]);
      this.sourceList = JSON.parse(
        JSON.stringify(data_beian)
          .replace(/theType/g, "name")
          .replace(/theNumber/g, "value")
      );
      var myChart = echarts.init(document.getElementById("echart_quality_one"));
      var option = {
        color: ["#6FC5FF", "#E0BB4B", "#3FC7BE"],
        legend: {
          data: this.oneType,
          x: "center",
          y: "95%",
          textStyle: {
            color: "#ffffff", // 图例文字颜色
            fontSize:16
          },
        },
        series: [
          {
            name: "半径模式",
            type: "pie", //这个type决定了你画的图的类型是饼图还是柱状图等
            radius: "70%", //饼图的内环和外环的半径
            center: ["50%", "50%"], //玫瑰图在画布上的相对位置
            // roseType: 'radius',//这里可以选择radius或area
            itemStyle: {
              normal: {
                // color: 各异,
                borderWidth: 1,
                label: {
                  show: true, //数据标签显示
                  position: "inner",
                  //数据标签的字体配置，与其他组件相同
                  textStyle: {
                    fontSize: 20, //字号
                    fontWeight: "normal", //粗细【normal\bold\bolder\lighter】
                    fontFamily: "PingFang-SC-Medium", //字体【 'serif'\'monospace'\'Arial'\'Courier New'\'Microsoft YaHei'】
                    color: "#ffffff", //颜色各异
                  },
                  formatter: "{b} {d}%", //a:系列名，就是你上面写的name半径模型，b：数据名，就是rose1，c：数据值，d百分比
                },
                labelLine: {
                  show: false, //数据标签引导线
                  length: 30,
                  lineStyle: {
                    width: 1,
                    type: "solid",
                  },
                },
              },
              emphasis: {
                //选中的样式
                borderColor: "rgba(0,0,0,0)",
                borderWidth: 1,
                label: {
                  show: true, //选中时不显示数据标签
                },
                labelLine: {
                  show: true, //选中时不显示数据标签引导线
                  lineStyle: {
                    width: 1,
                    type: "solid",
                  },
                },
              },
            },
            data: this.sourceList,
          },
          {
            name: "外边框",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            center: ["50%", "50%"],
            radius: ["75%", "75%"],
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              show: false, //数据标签引导线
              length: 30,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            emphasis: {
              show: false,
              //选中的样式
              borderColor: "rgba(0,0,0,0)",
              borderWidth: 1,
              label: {
                show: false, //选中时不显示数据标签
              },
              labelLine: {
                show: false, //选中时不显示数据标签引导线
                lineStyle: {
                  width: 1,
                  type: "solid",
                },
              },
            },
            data: [
              {
                value: 9,
                name: "",
                itemStyle: {
                  normal: {
                    borderWidth: 1,
                    borderColor: "#ffffff",
                  },
                },
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option);
      myChart.on("click", (params) => {
        this.getList(params.name);
      });
    },
    // 产品统计-育苗产品
    init_two() {
      // 接口
      var data_heke = plOtherDataInterface.getZlsyPlantProductStaticList();
      let List = data_heke.seedList;
      let arr1 = [];
      let arr2 = [];
      let arr3 = [];
      List.forEach((element) => {
        arr1.push(element[0]);
        arr2.push(element[1]);
        arr3.push(element[2]);
      });
      var myChart = echarts.init(document.getElementById("echart_quality_two"));
      var option = {
        color: ["#6FC5FF", "#CEFD65"],
        legend: {
          data: ["生鲜类", "素食类"],
          textStyle: { color: "#fff",fontSize:16 },
          x: "center", //居右显示
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var showHtm = params[0].name+ "<br>" ;
            for (var i = 0; i < params.length; i++) {
              showHtm += params[i].seriesName+":"+params[i].data+"箱"+"<br>"
            }
            return showHtm;
          },
        },
        xAxis: {
          type: "category",
          data: arr1,
          axisLabel: {
            show: true,
            interval: 0, //设置间隔为0
            textStyle: {
              color: "#fff",
              fontSize:16
            },
          },
          axisTick: {
            //x轴刻度线
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: ["#ccc"],
              width: 1,
              type: "dashed",
            },
          },
        },
        yAxis: [
          {
            name: "生鲜类(箱)",
            type: "value",
           splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
          {
            name: "素食类(箱)",
            type: "value",
            min: 0,
           splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 1,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          { type: "bar", name: "生鲜类",yAxisIndex: 1, data: arr2 },
          { type: "bar", name: "素食类", data: arr3 },
        ],
      };
      option && myChart.setOption(option);
    },
    // 产品统计-屠宰产品
    init_three() {
      // 接口
      var data_jingying = plOtherDataInterface.getZlsyTuzaiProductStaticList();
      this.twoYear = data_jingying.theYear;
      this.sheepList = data_jingying.sheepList;
      this.cowList = data_jingying.cowList;
      var option = {
        color: ["#FADB7D", "#FA7D7D"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            return `
              <div style="font-size:12px;">${params[0].seriesName}:${params[0].data}头</div>
              <div style="font-size:12px;">${params[1].seriesName}:${params[1].data}只</div>
            `;
          },
        },
        legend: {
          data: [
            { name: "牛", textStyle: { color: "#fff" ,fontSize:16} },
            { name: "羊", textStyle: { color: "#fff" ,fontSize:16} },
          ],
        },
        
        xAxis: [
          {
            type: "category",
            data: this.twoYear,
            axisLabel: {
              show: true,
              interval: 0, //设置间隔为0
              textStyle: {
                color: "#fff",
                fontSize:16
              },
            },
            axisTick: {
              //x轴刻度线
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 2,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "数量",
            type: "value",
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: ["#ccc"],
                width: 2,
                type: "dashed",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
          },
        ],
        series: [
          {
            name: "牛",
            type: "line",
            smooth: false,
            label: {
              show: true,
              position: "top",
               color: "#fff",
            },
            yAxisIndex: 0,
            data: this.cowList,
          },
          {
            name: "羊",
            type: "line",
            label: {
              show: true,
              position: "bottom",
               color: "#fff",
            },
            smooth: false,
            yAxisIndex: 0,
            data: this.sheepList,
          },
        ],
      };
      var myChart = echarts.init(
        document.getElementById("echart_quality_three")
      );

      option && myChart.setOption(option);
    },
    getList(a) {
      var res = plOtherDataInterface.getZlsyCompanyInfoByTypeList(a);
      console.log(res + "1112");
      this.tableList = res;
      console.log(this.tableList);
    },
  },
};
</script>
<style lang="less" scoped>
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-bottom: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  padding-top: 1.875rem;
}
#echart_quality_three,
#echart_quality_two {
  height: 18.75rem;
}
#echart_quality_one {
  float: left;
  width: 40%;
  height: 25rem;
}
.suyuanBox {
  width: 100%;
}
.suyuandetail {
  float: left;
  width: 55%;
  height: 27rem;
  position: relative;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
// ::-webkit-scrollbar {
//   background-color: #15606e;
//   width: 1px;
// } /* 这是针对缺省样式 (必须的) */
// ::-webkit-scrollbar-thumb {
//   background: #00574a;
//   width: 1px;
//   border-radius: 2px;
// } /* 滑块颜色 */

// 明细表格样式
.div {
  width: 100%;
  height: 26rem;
  position: absolute;
  top: 4rem;
}

.table_border {
  overflow: auto;
  height: 20rem;
}
.border_height {
  padding: 35px 20px 10px;
}
.table {
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
}
table tbody {
    display: block;
    max-height: 17rem;            
    overflow-y: auto;
     -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
     display: none;
   }
}
table thead,
tbody tr {
    display: table;
    table-layout: fixed; /* 使用表格固定算法 必须配合上面一起使用 */
    width: 100%;
    text-align: center; 
}
.table_cont {
  width: 100%;
  border-collapse: collapse;
  color: #fff;
  font-size: 16px;
  border: 1px solid rgba(131,170,190,0.68);
  td {
    padding: 10px 0;
    border: 1px solid rgba(131,170,190,0.68);
     white-space:normal;
  }
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
.monthBox {
  width: 100%;
  text-align: center;
  p {
    font-size: 30px;
    color: #fff;
  }
}
.demonstration {
  color: #fff;
  font-size: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/detail_quality/traceSource.vue